import { render } from "./ModalNuovoInterventoFromTicket.vue?vue&type=template&id=525dd3fb&scoped=true"
import script from "./ModalNuovoInterventoFromTicket.vue?vue&type=script&lang=js"
export * from "./ModalNuovoInterventoFromTicket.vue?vue&type=script&lang=js"

import "./ModalNuovoInterventoFromTicket.vue?vue&type=style&index=0&id=525dd3fb&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_mmx/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525dd3fb"]])

export default __exports__